import { createSlice } from "@reduxjs/toolkit";
export const ResendCodeSlice = createSlice({
  name: "ResendCode",
  initialState: {
    ResendCode: {},
  },
  reducers: {
    getResendCode: (state, action) => {
      state.ResendCode = action.payload;
    },
  },
});
export const { getResendCode } =
  ResendCodeSlice.actions;
export default ResendCodeSlice.reducer;
